import axios, { type AxiosRequestConfig } from "axios";
import { getURLPrefix } from "utils/getUrlPrefix";

const URL_PREFIX = getURLPrefix();

const get = async <T = unknown>(
  endpoint: string,
  params?: AxiosRequestConfig["params"],
  config?: AxiosRequestConfig,
) => {
  if (params) {
    config = { params, ...config };
  }
  return await axios.get<T>(`${URL_PREFIX}${endpoint}`, config);
};

const post = async <T = unknown>(endpoint: string, body?: unknown, params?: AxiosRequestConfig["params"]) => {
  const config = params && { params };
  return await axios.post<T>(`${URL_PREFIX}${endpoint}`, body, config);
};

const put = async <T = unknown>(endpoint: string, body?: unknown, params?: AxiosRequestConfig["params"]) => {
  const config = params && { params };
  return await axios.put<T>(`${URL_PREFIX}${endpoint}`, body, config);
};

const patch = async <T = unknown>(endpoint: string, body?: unknown, params?: AxiosRequestConfig["params"]) => {
  const config = params && { params };
  return await axios.patch<T>(`${URL_PREFIX}${endpoint}`, body, config);
};

const remove = async <T = unknown>(endpoint: string, params?: AxiosRequestConfig["params"]) => {
  const config = params && { params };
  return await axios.delete<T>(`${URL_PREFIX}${endpoint}`, config);
};

export default { get, post, put, remove, patch };
